// ES Module import
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDnNUhdB-tXoai230teZWZFw2lKgGOC0tQ",
  authDomain: "landlordfix-abtanjir.firebaseapp.com",
  projectId: "landlordfix-abtanjir",
  storageBucket: "landlordfix-abtanjir.firebasestorage.app",
  messagingSenderId: "916839974658",
  appId: "1:916839974658:web:8cf4e35e3ddbceb68ba41b",
  measurementId: "G-98RJVPC3D4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const vapid = "BKZ3Na5ICdaMGhtzS2ZHcyWJoDmZSn6yXMeB-Akm989EoFFhAgjad5eZvrkKmo87mB0SIac9qTX1MOGzEWy4LFY";

function generateDeviceId() {
    if (window.crypto && crypto.randomUUID) {
        return crypto.randomUUID();
    } else {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

async function registerFcmToken() {
    try {
        // Request notification permission
        let permission = Notification.permission;
        if (permission !== "granted") {
            permission = await Notification.requestPermission();
        }
        if (permission !== "granted") {
            console.warn("Notifications permission not granted");
            return;
        }

        // Ensure service worker is ready
        if (!('serviceWorker' in navigator)) {
            console.error("Service Worker not supported in this browser.");
            return;
        }
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        await navigator.serviceWorker.ready;

        if (!registration.pushManager) {
            console.error("PushManager unavailable, cannot get FCM token");
            return;
        }

        // Stable device ID
        let deviceId = localStorage.getItem("device_id");
        if (!deviceId) {
            deviceId = generateDeviceId();
            localStorage.setItem("device_id", deviceId);
        }

        const dataKey = "fcm_token:" + deviceId;
        const lastRefreshKey = "fcm_token_refresh:" + deviceId;
        const tokenKey = "fcm_token_value:" + deviceId;
        const now = Date.now();
        const twentyFourHours = 24 * 60 * 60 * 1000;

        // Check existing token
        const lastRefresh = localStorage.getItem(lastRefreshKey);
        const existingToken = localStorage.getItem(tokenKey);
        if (existingToken && lastRefresh && (now - parseInt(lastRefresh) < twentyFourHours)) {
            console.log("FCM token is still valid, skipping refresh");
            return existingToken;
        }

        // Get a new token
        const token = await getToken(messaging, { vapidKey: vapid, serviceWorkerRegistration: registration });
        if (!token) {
            console.warn("FCM token not available");
            return;
        }

        // Save token to server
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        const response = await fetch(url + "/api/userdata/setFcmTokenWithTopic", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-CSRF-TOKEN": csrfToken
            },
            body: JSON.stringify({ data_key: dataKey, value: token })
        });

        const result = await response.json();
        console.log("FCM token saved:", result);

        // Update localStorage
        localStorage.setItem(tokenKey, token);
        localStorage.setItem(lastRefreshKey, now.toString());

        return token;

    } catch (error) {
        console.error("Error during FCM registration:", error);
    }
}

// Foreground messages
onMessage(messaging, (payload) => {
    console.log("Notification Permission: ", Notification.permission);
    if (Notification.permission === "granted") {
        new Notification(payload.data.title, {
            body: payload.data.body,
            icon: "/storage/images/favicon.png"
        });
    }
});

export { registerFcmToken };
// Expose globally
window.registerFcmToken = registerFcmToken;
